module.exports = "https://cdn.realtymogul.com/static/media/icon_smart_message.2fc985f4.svg";